const paydunya= require('paydunya');

const setup = new paydunya.Setup({
    masterKey: process.env.VUE_APP_PAYDUNYA_MASTER_KEY,
    privateKey: process.env.VUE_APP_PAYDUNYA_PRIVATE_KEY,
    publicKey: process.env.VUE_APP_PAYDUNYA_PUBLIC_KEY,
    token: process.env.VUE_APP_PAYDUNYA_TOKEN,
    mode: 'test' // Optionnel. Utilisez cette option pour les paiements tests.
});

// Configuration des informations de votre service/entreprise
const store = new paydunya.Store({
    name: 'Jabali', // Seul le nom est requis
    tagline: "La digitalisation pour vous simplifier la vie",
    phoneNumber: '77.098.31.77',
    postalAddress: 'Dakar Ouakam - Cité Assemblée Nationale',
    websiteURL: 'https://www.jabali-web.sens-numerik.com',
    logoURL: 'https://jabali-web.sens-numerik.com/Logo_TSA_fine_small.ico',
    /*callbackURL: 'https://jabali-web.sens-numerik.com/paydunya/paymentcallback',
    cancelURL: 'https://jabali-web.sens-numerik.com/paydunya/paymentcancel',
    returnURL: 'https://jabali-web.sens-numerik.com/paydunya/paymentcallback'*/
    callbackURL: 'https://8dca-102-164-172-113.ngrok-free.app/paydunya/paymentcallback',
    cancelURL: 'http://localhost:8081/paydunya/paymentcancel',
    returnURL: 'http://localhost:8081/paydunya/paymentsuccess'
});

export const invoice = new paydunya.CheckoutInvoice(setup, store);

